var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"status-dot",class:_vm.classNameText}),_c('span',{staticClass:"status-text",staticStyle:{"margin-left":"8px"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }